import {Injectable} from '@angular/core';
import {BaseProvider} from '../base.provider';
import {JobService} from './job.service';
import {SelectValueInterface} from '@interfaces/select-value.interface';

@Injectable()
export class JobProvider extends BaseProvider<SelectValueInterface[]> {
    public defaultValue: SelectValueInterface[] = [{id: 'custom', title: 'Свое название должности'}];

    constructor(
        service: JobService
    ) {
        super(service);
        /**
         * Устанавливаем дефолтные значения
         */
        this.data$.next(this.defaultValue);
        this.updateData();
    }

    public processedData(data: SelectValueInterface[]): SelectValueInterface[] {
        return data.concat(this.defaultValue);
    }
}
